import Vue from 'vue'
import Vant from 'vant' // 引入vant
import 'vant/lib/index.css' // 引入vant样式

// import './plugins/swiper-5.4.5/package/css/swiper.min.css'
import 'swiper/css/swiper.min.css'

import './assets/myStyle.css'
import './plugins/element.js'
import './utils/rem'
import store from './store' //引入 Vuex 状态管理
import baseUrl from './api/baseUrl'  //引入全局baseUrl
import moment from 'moment'   //引入全局moment
import './router/routerBefore'
import App from './App.vue'
import router from './router' //引入路由配置
Vue.prototype.baseUrl = baseUrl
Vue.prototype.$moment = moment;
import { RsaEncrypt, RsaDecrypt, AesEncrypt, AesDecrypt, randomString, sendParam, paramDecrypt } from './utils/rsa';  //引入全局加密方法
Vue.prototype.RsaEncrypt = RsaEncrypt;
Vue.prototype.RsaDecrypt = RsaDecrypt;
Vue.prototype.AesEncrypt = AesEncrypt;
Vue.prototype.AesDecrypt = AesDecrypt;
Vue.prototype.randomString = randomString;
Vue.prototype.sendParam = sendParam;
Vue.prototype.paramDecrypt = paramDecrypt;



Vue.use(Vant)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router, //使用路由配置
  store, //使用 Vuex 进行状态管理
}).$mount('#app')
